import React,{useEffect} from "react";
import Sidebar from "../Components/TeacherDashboard/Sidebar";
import PaginationData from "../Components/TeacherDashboard/PaginationData";
import Header from "../Components/TeacherDashboard/Header";
import { Center } from "@chakra-ui/react";
import axios from "axios";
import Button from "@mui/material/Button";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from "../theme"
import { useNavigate } from "react-router-dom";

function DashboardScholarship() {
  const navigate=useNavigate()

  useEffect(()=>{
    const existingToken = localStorage.getItem('sbpathshalaAdmin');
    if(existingToken){
      navigate("/teachers/dashboard/scholarship")
    }else{
      navigate("/")
    }
  })

  const handleExport = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/teacherlogin/studentalldata`);
      const data = response.data.data;
      
      if (!data || !Array.isArray(data) || data.length === 0) {
          console.error("Invalid or empty data received");
      } else {
          // Flatten the address object
          const flattenedData = data.map(student => {
              return {
                  registrationno: student.registrationno,
                  name: student.name,
                  fathername: student.fathername,
                  dateofbirth: student.dateofbirth,
                  mobileno: student.mobileno,
                  gender: student.gender,
                  // Flatten address object
                  state: student.address.state,
                  city: student.address.city,
                  village: student.address.village,
                  post: student.address.post,
                  pincode: student.address.pincode,
                  img: student.img,
                  fees: student.fees,
                  paymentid: student.paymentid,
                  aadharno: student.aadharno,
                  category: student.category,
                  aim: student.aim,
                  schoolname: student.schoolname,
                  teachername: student.teachername,
                  teacherno: student.teacherno,
              };
          });
      
          const worksheet = XLSX.utils.json_to_sheet(flattenedData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      
          // Use XLSX.writeFile for simplicity
          XLSX.writeFile(workbook, "student_data.xlsx");
      }
        
      } catch (error) {
        console.error("Error exporting data to Excel:", error);
      }
  };

  return (
    <>
       <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ width: "100%", display: "flex" }}>
        <div style={{ width: "10%" }}>
          <Sidebar />
        </div>
        <div style={{ width: "90%" }}>
          <Header />
          <div>
            <Center my="20px">
              <h3 style={{ fontFamily: "Arvo", fontSize: "3xl", color: "blue" }}> Register Students for Scholarships</h3>
            </Center>
            <Center my="20px">
              <Button variant="contained" onClick={handleExport}>
                Export data to an Excel file
              </Button>
            </Center>
          </div>
          <PaginationData />
        </div>
      </div>
      </ThemeProvider>
    </>
  );
}

export default DashboardScholarship;
